<template>
  <input type="text"
         :name="fieldName"
         aria-label="Validation"
         hidden />
</template>

<script>
  import { onMounted, ref } from 'vue';
  export default {
    name: 'ReCaptchaInput',
    props: {
      fieldName: {
        type: String,
        required: true,
      },
      siteKey: {
        type: String,
        required: true,
      },
    },
    setup(props) {
      onMounted(() => {
        const input = document.querySelector(`input[name=${props.fieldName}]`);

        if (input) {
          const form = input.closest('form');

          const handler = (e) => {
            e.preventDefault();

            grecaptcha.ready(function () {
              grecaptcha.execute(props.siteKey, { action: 'submit' })
                .then(function (token) {
                  input.value = token;
                  e.target.submit();
                });
            });
          };

          if (form) {
            form.addEventListener('submit', handler);
          }
        }
      })

      return {}
    }
  }
</script>
